import nayeem from "../assets/core/Nayeem.png";
import sat from "../assets/core/satyam.jpeg";
import mm from "../assets/core/mm.jpeg";
import vk from "../assets/core/vk.jpeg";
import tk from "../assets/core/tk.jpeg";
import jd from "../assets/core/jd.jpeg";
import teja from "../assets/core/teja.JPG";
import ts from "../assets/core/ts.jpeg";
import shar from "../assets/core/shar.jpg";
import harshit from "../assets/core/harshith.JPG";
import wsk from "../assets/core/wsk.jpg"
import wamk from "../assets/core/wamk.jpg"
import wap from "../assets/core/wap.jpg"
import wc from "../assets/core/wc.jpg"
import wcp from "../assets/core/wcp.jpeg"
import wgt from "../assets/core/wg.jpg"
import wkc from "../assets/core/wkc.jpg"
import wkm from "../assets/core/wkm.jpeg"
import wl from "../assets/core/wl.jpg"
import wmsb from "../assets/core/wmsb.jpg"
import wso from "../assets/core/wso.jpg"
import wta from "../assets/core/wta.jpg"
import hc from "../assets/core/hc.jpeg"
import wva from "../assets/core/wva.jpeg"
export const webTeamData = [
  {
    pic: nayeem,
    name: "Nayeem",
  },
  {
    pic: wamk,
    name: "Ayaz",
  },
  {
    pic: wgt,
    name: "Ganesh",
  },
  {
    pic: wc,
    name: "sai chandra ",
  },
  {
    pic: wta,
    name: "Abhiram",
  },
  {
    pic: wcp,
    name: "Chaitanya",
  },
  {
    pic: wap,
    name: "Pavan",
  },
  {
    pic: wmsb,
    name: "Shrinivas Balaji",
  },
  {
    pic: wso,
    name: "Somanath Reddy",
  },
  {
    pic: wkm,
    name: "Karthikeya madhavan",
  },
  {
    pic: wkc,
    name: "Charan",
  },
  {
    pic: wl,
    name: "Lithin ",
  },
  {
    pic: wsk,
    name: "Shivam Kumar",
  },
  {
    pic: wva,
    name: "Varun",
  },
];

export const teamData = {
  Core: [
    {
      name: "Harshith",
      pic: harshit,
      role: "Techkriya Secretary",
    },
    {
      name: "Nayeem",
      pic: nayeem,
      role: "Web Dev Secretary",
    },
    {
      name: "Satyam",
      pic: sat,
      role: "Technical Secretary",
    },
    {
      name: "Teja",
      pic: teja,
      role: "Promotion and PR Secretary",
    },
    {
      name: "Sharvan",
      pic: shar,
      role: "Cultural Secretary",
    },
    {
      name: "Maruthi Mahesh",
      pic: mm,
      role: "Stalls and Activities Secretary",
    },
    {
      name: "Vijay krishna",
      pic: vk,
      role: "Security Team Secretary",
    },
    {
      name: "Tharun Kalyan",
      pic: tk,
      role: "Stage Operations Secretary",
    },
    {
      name: "Teja Surya",
      pic: ts,
      role: "Design and Media Secretary",
    },
    {
      name: "Jagadeesh Kotapati",
      pic: jd,
      role: "Hospitality Secretary",
    },
    {
      name:"Harshit Chaturvedi",
      pic:hc,
      role:"Sponsorship Secretary"
    }
  ],
};
